import { ReactComponent as CardiVue } from 'img/autoseg_logo.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Logo.module.scss';
import { useAnalysisPage } from '@features/analysis/useAnalysisPage';
import { ToolItemConfig } from 'config/toolsConfig';
import { usePanelContainer } from '@features/analysis/rendering/Panels/usePanelContainer';
import { deactivateExclusiveTools } from '@features/analysis/rendering/Panels/Renderers/CornerstoneManager';
import { useSegmentManager } from '@features/analysis/segmentManager';
import { configStore } from 'config/configStore';

export interface LogoAndTitleProp {
  goList?: boolean;
  className?: string;
}

const LogoAndTitle = ({ goList = true, className }: LogoAndTitleProp) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { activatedTools, updateSwitchConfigs, updateSelectedTool } =
    useAnalysisPage();
  const { analysisType } = usePanelContainer();
  const { mode: manualMode } = useSegmentManager();

  const analysisTypeSuffixMap: Partial<Record<string, string>> = {
    preview: 'Preview',
    MPR: 'MPR',
    segmentation: 'Segmentation',
    plaque: 'Plaque',
    chamber: 'Chamber',
    stenosis: 'Stenosis',
    calciumScore: 'CAC',
    aorticValveCalcium: 'AVC',
    fai: 'FAI',
    isr: 'ISR',
    myocardial: 'Myocardial',
    wallthickness: 'LAWT',
    ejectionFraction: 'EF',
    tavi: 'TAVI',
    FFR: 'CT-FFR',
  };
  const isBrowserRoute = location.pathname.startsWith('/browser');
  const logoText = isBrowserRoute
    ? 'CardiVue'
    : analysisTypeSuffixMap[analysisType]
      ? `CardiVue-${analysisTypeSuffixMap[analysisType]}`
      : 'CardiVue';

  return (
    <div
      className={`${styles.logoContainer} ${
        !!(manualMode && configStore.get().EditMode) ? styles.disabled : ''
      } ${className ?? ''}`}
      onClick={() => {
        if (!goList ||  !!(manualMode && configStore.get().EditMode)) return;
        deactivateExclusiveTools({ isScrollTool: true }); // 마우스 왼쪽버튼 스크룰 고정하기
        if (activatedTools['switchSegmentManagerTools']) {
          // 시리즈 변경 시 segment manager 초기화하는 코드
          const item = {
            id: 'switchSegmentManagerTools',
            isExclusive: false,
            isToggleable: true,
            name: 'Segment Manager',
          } as ToolItemConfig;
          updateSelectedTool({ ...item, groupName: 'segmentManager' });
          updateSwitchConfigs({ switchSegmentManagerTools: false });
        }
        navigate('/browser');
      }}
    >
      <CardiVue className={styles['logo']} />
      <span className={styles['title']}>{logoText}</span>
    </div>
  );
};

export default LogoAndTitle;
